import { Outlet } from "react-router-dom";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { Nav } from "./Nav";
import { Footer } from "./Footer";
import { useSettings, waLink } from "../../lib/api";

export const WhatsAppFab = () => {
  const s = useSettings();
  return (
    <motion.a
      data-testid="whatsapp-fab"
      href={waLink(s.whatsapp)}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.6, type: "spring", stiffness: 260, damping: 18 }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-5 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_10px_40px_-8px_rgba(37,211,102,0.7)]"
    >
      <MessageCircle className="h-6 w-6" />
    </motion.a>
  );
};

export const SiteLayout = () => (
  <div className="min-h-screen bg-white">
    <Nav />
    <main><Outlet /></main>
    <Footer />
    <WhatsAppFab />
  </div>
);
